import React from 'react';
import cx from 'classnames';
import { themr } from "../theme/themr";

// nextiva asset
import tooltipIcon from '../assets/tooltip-icon.png';

// own styles
import Styles from './XbertTooltip.scss';
//import Tooltip from 'analytics-ui/Tooltip/Tooltip';
import { Tooltip } from '@nextiva/next-ui';


const renderTipContent = (tipContent) => (
  <>
    <h4>XBert tip:</h4>
    {tipContent}
  </>
);

const XbertTooltip = (props) => {
  const { tipId, tipItem, tipClass, tipContent = '', theme } = props;

  return (
    <Tooltip
      id={tipId}
      delay={700}
      placement="bottom"
      text={renderTipContent(tipContent)}
      popoverClassName={cx(theme.xbertTooltip, tipClass)}
    >
      {tipItem || <img src={tooltipIcon} alt="Tooltip" />}
    </Tooltip>
  );
};

export default themr(XbertTooltip, Styles);
